/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/href-no-hash */
import React, { Component } from 'react';
import { Input } from 'semantic-ui-react';

import './PackageBuilderSearch.css';

class PackageBuilderSearch extends Component {
  state = {
    name: ''
  };

  handleFormChange = async (event) => {
    await this.setState({
      name: event.target.value
    });
    this.filterName();
  };

  filterName = () => {
    const { name } = this.state;
    this.props.fetchPackagesWithName(1, name);
  };

  render() {
    const { name } = this.state;
    return (
      <div>
        <Input
          className="search-name"
          placeholder="Name"
          type="text"
          name="name"
          value={name}
          onChange={this.handleFormChange}
        />
      </div>
    );
  }
}

export default PackageBuilderSearch;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/PackageBuilderSearch.js